module.exports = __webpack_public_path__ + "static/img/9.877d9ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/eng/9.png
// module id = PLKD
// module chunks = 0